import apiClient from './apiClient';

/**
 * Service for Geofencing and Location tracking.
 */
const geofencingService = {
    async getZones() {
        return await apiClient.get('/geofencing/zones');
    },

    // Every ACTIVE contract site: geofence polygon, customer, machine count.
    // The Operations Sites page draws these.
    async getSites() {
        return await apiClient.get('/geofencing/sites');
    },

    async getRecentViolations() {
        return await apiClient.get('/geofencing/violations');
    }
};

export default geofencingService;
